import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-market-refresh',
    templateUrl: './refresh.component.pug',
    styleUrls: ['./refresh.component.less']
})
export class RefreshComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
